<script setup>
import { computed } from 'vue';
import BaseBubble from './Base.vue';
import AudioChip from 'next/message/chips/Audio.vue';
import { useMessageContext } from '../provider.js';
import { MESSAGE_VARIANTS } from '../constants';

const { attachments, variant } = useMessageContext();

const attachment = computed(() => {
  return attachments.value[0];
});

// The audio chip carries its own card, so the bubble behind it is normally
// invisible. A private note is the exception: the amber background is what
// marks it as internal, so it has to stay.
const isPrivate = computed(() => variant.value === MESSAGE_VARIANTS.PRIVATE);

// Como no WhatsApp, o audio fica dentro da bolha de quem mandou: azul quando
// e do atendente, branca quando e do contato. Na azul o player vira branco.
const isAgent = computed(() => variant.value === MESSAGE_VARIANTS.AGENT);
</script>

<template>
  <BaseBubble
    class="w-[19rem] max-w-full"
    :class="[
      isPrivate ? 'p-2' : 'p-1',
      {
        'text-white [&_input]:!bg-white/40 [&_.text-n-slate-11]:!text-white [&_.text-n-slate-12]:!text-white [&_.bg-n-alpha-2]:!bg-white/20 [&_.bg-n-alpha-1]:!bg-white/10':
          isAgent,
      },
    ]"
    data-bubble-name="audio"
  >
    <AudioChip
      embedded
      :attachment="attachment"
      class="p-1 skip-context-menu"
      :class="{ 'text-n-slate-12': !isAgent }"
    />
  </BaseBubble>
</template>
